module.exports = __webpack_public_path__ + "img/350.1e9c51c0.png";